module.exports = __webpack_public_path__ + "static/media/wagyu_step_6.b47f0856.png";